/*
(((d, s, id) => {
	const fjs = d.getElementsByTagName(s)[0];
	if (d.getElementById(id)) {
		return;
	}
	const js = d.createElement(s);
	js.id = id;
	js.src = 'https://connect.facebook.net/en_US/sdk.js';
	fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk'));

export const initFbSdk = (Vue, facebookClientId) => {
	window.fbAsyncInit = () => {
		FB.init({
			appId: facebookClientId,
			autoLogAppEvents: true,
			xfbml: true,
			version: 'v2.12',
		});

		// FB.getLoginStatus( function( response ) {
		// 	console.log( 'getLoginStatus' , response );
		// 	if( response.status === 'connected' ) {
		// 		// return response.authResponse.accessToken;
		// 	}
		// });
	};

};*/

function Deferred() {
	var self = this;
	this.promise = new Promise(function(resolve, reject) {
		self.reject = reject;
		self.resolve = resolve;
	});
}
window.fbLoaded = (new Deferred());

const vue_fb = {
	install : function ( Vue, options ) {

		(function ( d, s, id ) {
			var js, fjs = d.getElementsByTagName(s)[ 0 ];
			if ( d.getElementById(id) ) {
				return;
			}
			js = d.createElement(s);
			js.id = id;
			js.src = "https://connect.facebook.net/en_US/sdk.js";
			fjs.parentNode.insertBefore(js, fjs);
		}(document, 'script', 'facebook-jssdk'));

		window.fbAsyncInit = () => {
			// console.log('fbAsyncInit');
			FB.init(options);
			fbLoaded.resolve();
			FB.AppEvents.logPageView();
			Vue.FB = FB;
			window.dispatchEvent(new Event('fb-sdk-ready'));
		};

		Vue.FB = undefined;
	}
};

export default vue_fb;





// WEBPACK FOOTER //
// ./src/utils/FB_SDK.js